// Impressum.js
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
    Box,
    Container,
    Typography,
    Card,
    CardContent,
    Button,
    Link as MLink,
    Divider,
} from "@mui/material";
import Footer from "../components/Footer";

// Branding colors (keep in sync with MainApp)
const BRAND_BLUE = "#0d396e";
const BRAND_GREEN = "#00C853";

const Impressum = () => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
            {/* HERO (same visual language as main page) */}
            <Box sx={{ bgcolor: "#fff", pt: { xs: 6, md: 10 } }}>
                <Container maxWidth="lg">
                    <Box sx={{ textAlign: "center", mb: { xs: 4, md: 6 } }}>
                        <MLink component={RouterLink} to="/" underline="none">
                            <Box
                                component="img"
                                src={`${process.env.PUBLIC_URL}/images/helloqr.png`}
                                alt="HelloQR"
                                sx={{
                                    width: 220,
                                    height: "auto",
                                    borderRadius: 2,
                                    display: "inline-block",
                                    mb: 4,
                                }}
                            />
                        </MLink>
                        <Typography
                            variant="h2"
                            component="h1"
                            sx={{ fontWeight: 800, color: BRAND_BLUE, lineHeight: 1.2 }}
                        >
                            Impressum
                        </Typography>
                        <Typography variant="h6" sx={{ color: "text.secondary", mt: 1 }}>
                            Rechtliche Angaben & Verantwortlichkeiten
                        </Typography>
                    </Box>
                </Container>
            </Box>

            {/* CONTENT CARD (matches card look of main page) */}
            <Box sx={{ bgcolor: "#f8fafc", py: { xs: 6, md: 10 }, flexGrow: 1 }}>
                <Container maxWidth="md">
                    <Card elevation={1} sx={{ borderRadius: 4 }}>
                        <CardContent sx={{ p: { xs: 3, md: 5 } }}>
                            {/* Verantwortlich */}
                            <Typography variant="h4" sx={{ fontWeight: 800, color: BRAND_BLUE, mb: 2 }}>
                                Verantwortlich für diese Seite
                            </Typography>
                            <Typography sx={{ mb: 3 }}>
                                Felix Hohlwegler<br />
                                Hebelstr. 13<br />
                                78244 Gottmadingen<br />
                                Tel: 07731 976692<br />
                                Mobil: 0174&nbsp;4054184<br />
                                <MLink href="mailto:info@felix-hohlwegler.de">info@felix-hohlwegler.de</MLink>
                            </Typography>

                            <Typography sx={{ mb: 3 }}>
                                <MLink href="https://www.felix-hohlwegler.de" target="_blank" rel="noopener noreferrer">
                                    www.felix-hohlwegler.de
                                </MLink>
                                <br />
                                Design und Realisierung: Felix Hohlwegler
                            </Typography>

                            <Divider sx={{ my: 4 }} />

                            {/* Haftungsausschluss */}
                            <Typography variant="h5" sx={{ fontWeight: 700, color: BRAND_BLUE, mb: 1 }}>
                                Haftungsausschluss
                            </Typography>

                            <Typography variant="h6" sx={{ fontWeight: 700, mt: 2 }}>
                                Inhalt des Onlineangebotes
                            </Typography>
                            <Typography sx={{ mb: 2 }}>
                                Der Autor übernimmt keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit
                                oder Qualität der bereitgestellten Informationen. Haftungsansprüche gegen den Autor,
                                welche sich auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung
                                oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter
                                und unvollständiger Informationen verursacht wurden, sind grundsätzlich ausgeschlossen,
                                sofern seitens des Autors kein nachweislich vorsätzliches oder grob fahrlässiges
                                Verschulden vorliegt. Alle Angebote sind freibleibend und unverbindlich. Der Autor
                                behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne
                                gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung
                                zeitweise oder endgültig einzustellen.
                            </Typography>

                            <Typography variant="h6" sx={{ fontWeight: 700, mt: 2 }}>
                                Verweise und Links
                            </Typography>
                            <Typography sx={{ mb: 2 }}>
                                Bei direkten oder indirekten Verweisen auf fremde Webseiten („Hyperlinks“), die
                                außerhalb des Verantwortungsbereiches des Autors liegen, würde eine
                                Haftungsverpflichtung ausschließlich in dem Fall in Kraft treten, in dem der Autor
                                von den Inhalten Kenntnis hat und es ihm technisch möglich und zumutbar wäre, die
                                Nutzung im Falle rechtswidriger Inhalte zu verhindern. Der Autor erklärt hiermit
                                ausdrücklich, dass zum Zeitpunkt der Linksetzung keine illegalen Inhalte auf den zu
                                verlinkenden Seiten erkennbar waren. Auf die aktuelle und zukünftige Gestaltung, die
                                Inhalte oder die Urheberschaft der verlinkten/verknüpften Seiten hat der Autor
                                keinerlei Einfluss. Deshalb distanziert er sich hiermit ausdrücklich von allen
                                Inhalten aller verlinkten/verknüpften Seiten, die nach der Linksetzung verändert
                                wurden. Diese Feststellung gilt für alle innerhalb des eigenen Internetangebotes
                                gesetzten Links und Verweise sowie für Fremdeinträge. Für illegale, fehlerhafte oder
                                unvollständige Inhalte und insbesondere für Schäden, die aus der Nutzung oder
                                Nichtnutzung solcherart dargebotener Informationen entstehen, haftet allein der
                                Anbieter der Seite, auf welche verwiesen wurde, nicht derjenige, der über Links auf
                                die jeweilige Veröffentlichung lediglich verweist.
                            </Typography>

                            <Typography variant="h6" sx={{ fontWeight: 700, mt: 2 }}>
                                Urheber- und Kennzeichenrecht
                            </Typography>
                            <Typography>
                                Der Autor ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten
                                Medien zu beachten, von ihm selbst erstellte Inhalte zu nutzen oder auf lizenzfreie
                                Materialien zurückzugreifen. Alle innerhalb des Internetangebotes genannten und ggf.
                                durch Dritte geschützten Marken- und Warenzeichen unterliegen uneingeschränkt den
                                Bestimmungen des jeweils gültigen Kennzeichenrechts und den Besitzrechten der
                                jeweiligen eingetragenen Eigentümer. Das Copyright für veröffentlichte, vom Autor
                                selbst erstellte Objekte bleibt allein beim Autor der Seiten. Eine Vervielfältigung
                                oder Verwendung solcher Inhalte in anderen elektronischen oder gedruckten
                                Publikationen ist ohne ausdrückliche Zustimmung des Autors nicht gestattet.
                            </Typography>

                            {/* Back to Home CTA */}
                            <Box sx={{ textAlign: "center", mt: 5 }}>
                                <Button
                                    component={RouterLink}
                                    to="/"
                                    variant="contained"
                                    size="large"
                                    sx={{ bgcolor: BRAND_GREEN, ":hover": { bgcolor: "#00B84A" } }}
                                >
                                    Zur Startseite
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                </Container>
            </Box>

            {/* FOOTER (same component as main) */}
            <Footer />
        </Box>
    );
};

export default Impressum;
